// Canonical repair status vocabulary shared by admin (RU) and customer (NO) views.
// Extends the existing statuses; does NOT create a parallel status system.
export const STATUS_KEYS = [
  "mottatt", "under_vurdering", "under_diagnostikk", "diagnose_utfort",
  "venter_godkjenning", "godkjent", "deler_bestilt", "under_reparasjon",
  "testing_kvalitet", "klar_for_henting", "utlevert", "ferdig", "kansellert",
];

// Linear journey used for the customer progress bar (excludes cancelled).
export const STATUS_FLOW = [
  "mottatt", "under_vurdering", "under_diagnostikk", "diagnose_utfort",
  "venter_godkjenning", "godkjent", "deler_bestilt", "under_reparasjon",
  "testing_kvalitet", "klar_for_henting", "utlevert",
];

export const STATUS_RU = {
  new_request: "Новый запрос", mottatt: "Принято", under_vurdering: "На оценке",
  under_diagnostikk: "Диагностика", diagnose_utfort: "Диагностика завершена",
  venter_godkjenning: "Ожидает одобрения клиента", godkjent: "Одобрено",
  deler_bestilt: "Ожидание деталей", under_reparasjon: "В ремонте",
  testing_kvalitet: "Тестирование / контроль качества", klar_for_henting: "Готово к выдаче",
  utlevert: "Выдано / Завершено", ferdig: "Завершено", kansellert: "Отменено",
};

export const STATUS_NO = {
  new_request: "Ny forespørsel", mottatt: "Mottatt", under_vurdering: "Til vurdering",
  under_diagnostikk: "Under diagnostikk", diagnose_utfort: "Diagnose utført",
  venter_godkjenning: "Venter på kundens godkjenning", godkjent: "Godkjent",
  deler_bestilt: "Venter på deler", under_reparasjon: "Under reparasjon",
  testing_kvalitet: "Testing / kvalitetskontroll", klar_for_henting: "Klar for henting",
  utlevert: "Utlevert / Fullført", ferdig: "Ferdig", kansellert: "Kansellert",
};

export const STATUS_EXPLAIN_NO = {
  new_request: "Vi har mottatt forespørselen din og oppretter saken.",
  mottatt: "Forespørselen din er registrert. Lever maskinen til verkstedet når det passer deg.",
  under_vurdering: "Saken din står i kø og blir vurdert av en tekniker.",
  under_diagnostikk: "Vi undersøker maskinen for å finne feilen. Dette kan ta noe tid.",
  diagnose_utfort: "Diagnosen er utført. Vi forbereder et prisoverslag til deg.",
  venter_godkjenning: "Vi venter på din godkjenning før vi går videre. Sjekk e-posten din.",
  godkjent: "Takk! Du har godkjent arbeidet, og vi setter i gang.",
  deler_bestilt: "Nødvendige deler er bestilt. Reparasjonen fortsetter så snart delene er på plass.",
  under_reparasjon: "Maskinen din er under reparasjon / service.",
  testing_kvalitet: "Arbeidet er utført, og maskinen testes før den er klar til henting.",
  klar_for_henting: "Maskinen din er klar for henting. Ta med ordrekoden.",
  utlevert: "Maskinen er utlevert. Takk for at du valgte oss!",
  ferdig: "Saken er avsluttet.",
  kansellert: "Saken er avsluttet / kansellert. Ta kontakt hvis du har spørsmål.",
};

export const STATUS_COLOR = {
  new_request: "bg-blue-100 text-blue-800 border-blue-200",
  mottatt: "bg-blue-100 text-blue-800 border-blue-200",
  under_vurdering: "bg-yellow-100 text-yellow-800 border-yellow-200",
  under_diagnostikk: "bg-yellow-100 text-yellow-800 border-yellow-200",
  diagnose_utfort: "bg-amber-100 text-amber-800 border-amber-200",
  venter_godkjenning: "bg-orange-100 text-orange-800 border-orange-200",
  godkjent: "bg-teal-100 text-teal-800 border-teal-200",
  deler_bestilt: "bg-purple-100 text-purple-800 border-purple-200",
  under_reparasjon: "bg-indigo-100 text-indigo-800 border-indigo-200",
  testing_kvalitet: "bg-cyan-100 text-cyan-800 border-cyan-200",
  klar_for_henting: "bg-green-100 text-green-800 border-green-200",
  utlevert: "bg-emerald-100 text-emerald-800 border-emerald-200",
  ferdig: "bg-emerald-100 text-emerald-800 border-emerald-200",
  kansellert: "bg-red-100 text-red-800 border-red-200",
};
